var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnSiteClassessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_37996",
    "data-name": "Group 37996",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.351,
    height: 31.862,
    viewBox: "0 0 34.351 31.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M25.763,0l8.588,15.931L25.763,31.862H8.588L0,15.931,8.588,0Z",
    transform: "translate(0 0)",
    fill: "#c7bf37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_exam_3054500",
    transform: "translate(11.038 8.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37998",
    "data-name": "Group 37998",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65384",
    "data-name": "Path 65384",
    d: "M139.595,23.1h.5v1.273a1.668,1.668,0,0,0,1.663,1.663h4.535a1.668,1.668,0,0,0,1.663-1.663V23.1h.5a1.419,1.419,0,0,1,1.415,1.415V36.846a1.419,1.419,0,0,1-1.415,1.415h-8.854a1.419,1.419,0,0,1-1.415-1.415V24.519A1.419,1.419,0,0,1,139.595,23.1Zm2.159-1.294h4.535a.908.908,0,0,1,.906.905v1.662a.908.908,0,0,1-.906.906h-4.535a.908.908,0,0,1-.906-.906V22.715A.908.908,0,0,1,141.754,21.81ZM140.1,27.789l.617.606,1.36-1.491.6.543-1.924,2.109-1.215-1.193Zm2.859.611h5.557v.789h-5.557ZM140.1,31.5l.617.606,1.36-1.491.6.543-1.924,2.109-1.215-1.193Zm2.859.611h5.557V32.9h-5.557Zm-2.859,3.1.617.606,1.36-1.491.6.543-1.924,2.109-1.215-1.193Zm2.859.611h5.557v.789h-5.557V35.82Z",
    transform: "translate(-138.18 -21.81)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnSiteClassessIcon);
export default __webpack_public_path__ + "static/media/onSiteClassessIcon.b81df48e9879dde7ed292e6142a703bd.svg";
export { ForwardRef as ReactComponent };